import {Component, forwardRef, Input} from '@angular/core';
import {FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators} from "@angular/forms";
import {CustomValidators} from "../validator/customValidators";
import {Observable} from "rxjs";
import {AddressType, IAddressTypeList} from "../model/interface/address-type.model.interface";
import {AddressTypeHelper} from "../helper/address-type.helper";
import {ISimpleSelectableDataList} from "../model/interface/simple-selectable-data.model.interface";
import {ObjectListHelper} from "../helper/object-list.helper";
import {LegalEntity} from "../model/legal-entity.model";
import {AddressService} from "../../core/services/address.service";
import {AbstractControlComponent} from "../abstract-control-value-accessor/abstract-control.component";

@Component({
  selector: 'app-new-address',
  templateUrl: './new-address.component.html',
  styleUrls: ['./new-address.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NewAddressComponent),
      multi: true,
    },
  ],
})
export class NewAddressComponent extends AbstractControlComponent {
  addressTypes: ISimpleSelectableDataList = ObjectListHelper.fromArray([]);
  @Input() customer: LegalEntity;
  @Input() label: string;
  @Input() fixedAddressType: AddressType;
  @Input() required: boolean = false;
  addressFormGroup: FormGroup;

  constructor(private formBuilder: FormBuilder,
              private addressService: AddressService) {
    super();
  }

  ngOnInit(): void {
    this.createForm();
    this.getAddressTypes();
  }

  private createForm() {
    this.addressFormGroup = this.formBuilder.group({
      typeId: [{value: null, disabled: this.fixedAddressType}, Validators.required],
      street: [null, Validators.required],
      estateNumber: [null, Validators.required],
      localNumber: [null],
      city: [null, [Validators.required, CustomValidators.cityValidator]],
      postalCode: [null, [Validators.required]]
    });
  }

  private getAddressTypes() {
    const request = this.createGetAddressTypesRequest();
    this.handleGetAddressTypeRequest(request);
  }

  private createGetAddressTypesRequest() {
    return this.addressService.getAddressTypes();
  }

  private handleGetAddressTypeRequest(request: Observable<IAddressTypeList>) {
    request
      .subscribe((types) => {
        this.addressTypes = AddressTypeHelper.toSelectableList(types);
        const typeId = types.data.find(data => data.type === this.fixedAddressType).id;
        this.addressFormGroup.patchValue({typeId})
      })
  }

  registerOnChange(fn: any): void {
    this.addressFormGroup.valueChanges.subscribe(fn);
  }

  writeValue(obj: any): void {
    this.addressFormGroup.reset();
    if (obj) {
      this.addressFormGroup.patchValue(obj);
    }
  }
}
